import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { title: String, content: String, buttonLabel: String, cancelBtnLabel: String }

  trigger(e) {
    e.preventDefault()

    document.querySelector("#confirm-deletion-modal")?.remove()

    const modal = App.components.confirmDeletionModal(
      e.currentTarget.href,
      this.titleValue,
      this.contentValue,
      this.buttonLabelValue,
      this.cancelBtnLabelValue,
    )

    document.body.appendChild(modal)

    App.modal(`#${modal.id}`, "show")
  }
}
